import { render, staticRenderFns } from "./manage_level.vue?vue&type=template&id=f2d43614&scoped=true&"
import script from "./manage_level.vue?vue&type=script&lang=js&"
export * from "./manage_level.vue?vue&type=script&lang=js&"
import style0 from "./manage_level.vue?vue&type=style&index=0&id=f2d43614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d43614",
  null
  
)

export default component.exports